import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AnalyticsDashboard from "../../../components/analytics/AnalyticsDashboard";
import { getAllSclasses } from "../../../redux/sclassRelated/sclassHandle";

export default function AdminAnalyticsPage() {
    const dispatch = useDispatch();
    const { currentUser } = useSelector((state) => state.user);
    const { sclassesList } = useSelector((state) => state.sclass);
    const schoolId = currentUser?._id;

    useEffect(() => {
        if (schoolId) dispatch(getAllSclasses(schoolId, "Sclass"));
    }, [dispatch, schoolId]);

    return <AnalyticsDashboard mode="admin" schoolId={schoolId} classOptions={Array.isArray(sclassesList) ? sclassesList : []} />;
}
